import type { SelectOption, SingleValueOption } from '../types.tsx';

export const isSingleValueOption = (option: SelectOption): option is SingleValueOption =>
	option.optionType === 'option' ||
	option.optionType === 'avatar' ||
	option.optionType === 'lozenge' ||
	option.optionType === 'field';
